<template>
  <div class="tw:bg-zinc-50 tw:border tw:p-4 tw:rounded-md tw:mb-3">
    <div class="tw:flex tw:items-center tw:justify-between tw:gap-2">
      <label :for="id">
        <slot name="label"></slot>
      </label>
      <div>
        <Toggle v-model="isOn" :id="id"/>
      </div>
    </div>
    <div v-show="isOn" class="tw:mt-3 tw:pt-3 tw:border-t">
      <slot name="content" v-bind:isOn="isOn"></slot>
    </div>
  </div>
</template>

<script setup>
import Toggle from '@/components/ui/Toggle.vue'
import { ref, watch } from 'vue'

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  id: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['input'])

const isOn = ref(props.value)

watch(isOn, (val) => {
  emit('input', val)
})
</script>

<style scoped>

</style>
